import React, { useState } from 'react'

import ShippingInfoPrefFormProperties from './ShippingInfoPrefFormProperties'
import CompanyPreferenceTranslationText from '../shared/CompanyPreferenceTranslationText'
import CompanyPreferenceApiUrls from 'src/apiUrls/CompanyPreferenceApiUrls'
import { components, useServices } from 'cng-web-lib'

const {
  form: { CngViewForm },
  table: { useDefaultNotification }
} = components

function ShippingInfoPrefPage({ showNotification }) {
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [isSubmitting, setSubmitting] = useState(false);
  const translatedTextsObject = CompanyPreferenceTranslationText()
  const { updateRecord } = useServices()
  const { success: showSuccessNotification, error: showErrorNotification } =
    useDefaultNotification(showNotification)

  function onSubmit(data) {
    console.log('submit', data)
    setLoading(true)
    setSubmitting(true)

    function onError(error) {
      console.log('connection-request error', error.message)
      setLoading(false)
      setSubmitting(false)
      showErrorNotification(error.message)
    }

    function onSuccess(response) {
      console.log('connection-request onSuccess', response)
      setLoading(false)
      setSubmitting(false)
      setRefresh(!refresh)
      if (response.errorMessages != null) {
        showErrorNotification(response.errorMessages)
      } else {
        showSuccessNotification(
          `${translatedTextsObject.updateSubmitSuccessMsg}`
        )
      }
    }

    updateRecord.execute(
      CompanyPreferenceApiUrls.SI_PREF_PUT,
      data,
      onSuccess,
      onError
    )
  }

  return (
    <CngViewForm
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      showNotification={showNotification}
      bodySection={
        <ShippingInfoPrefFormProperties.FormFields
          disabled={false}
          showNotification={showNotification}
          loading={loading}
          setLoading={setLoading}
          refresh={refresh}
          isSubmitting={isSubmitting}
        />
      }
      formikProps={{
        ...ShippingInfoPrefFormProperties.formikProps,
        onSubmit: onSubmit
      }}
    />
  )
}

export default ShippingInfoPrefPage
